/** 游戏工具 id，用于数据中台上报，各项目按自身 manifest.json 中的 toolId 填写 */
export const TOOL_ID = "o61u0w85";

/** 游戏工具类型，用于数据中台上报，见 GameToolInfo.toolType (map=3, wiki=1) */
export const TOOL_TYPE = 3;

/** 游戏 ID，来源于 map-download/map.meta.json */
export const GAME_ID = "4319";

/** 共享游戏工具 Runtime 使用的工具 ID，沿用旧聚合导航配置 */
export const RUNTIME_TOOL_ID = "o61u0w85";

export const env = {
  uid: "0", // 用户 uid, 用于日志上下文或登录校验
};
